import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import {UserInfo} from "../api/AuthApi";
import {checkAuthStatus} from "./HealthCheckHelper";

interface AuthContextType {
    loggedIn: boolean;
    setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
    setUserInfo: React.Dispatch<React.SetStateAction<UserInfo>>;
    loading: boolean;
    userInfo: UserInfo;
}

const AuthContext = createContext<AuthContextType>({
    loggedIn: false,
    setLoggedIn: () => {
    },
    setUserInfo: () => {
    },
    loading: true,
    userInfo: {
        tenantId: "",
        email: ""
    }
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [loggedIn, setLoggedIn] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [userInfo, setUserInfo] = useState<UserInfo>({
        tenantId: "",
        email: ""
    });

    useEffect(() => {
        const checkLogin = async () => {
            try {
                const userInfo = await checkAuthStatus();
                    if (userInfo) {
                        setLoggedIn(true);
                        setUserInfo(userInfo);
                    }
            } finally {
                setLoading(false);
            }
        };

        checkLogin();
    }, []);

    const providerValue = useMemo(() => ({
        loggedIn,
        setLoggedIn,
        setUserInfo,
        loading,
        userInfo
    }), [loggedIn, loading, userInfo]);

    return (
        <AuthContext.Provider value={providerValue}>
            {children}
        </AuthContext.Provider>
    );
};


export const useAuth = () => {
    return useContext(AuthContext);
};